import React from 'react';

const AboutUsPage = (): JSX.Element => {
  return <h1>About us</h1>;
};

export default AboutUsPage;
